module.exports = __webpack_public_path__ + "img/field-level-endzone-gal-7.cae93c89.jpg";